"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import React from "react";
import { ContentTabProvider } from "../brain/ContentTabContext";
import WavesMessagesWrapper from "../shared/WavesMessagesWrapper";
interface Props {
  readonly children: ReactNode;
  readonly showLeftSidebar?: boolean | undefined;
}
const WavesDesktop: React.FC<Props> = t0 => {
  const $ = _c(3);
  const {
    children,
    showLeftSidebar: t1
  } = t0;
  const showLeftSidebar = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== children || $[1] !== showLeftSidebar) {
    t2 = <WavesMessagesWrapper defaultPath="/waves" showLeftSidebar={showLeftSidebar}>{children}</WavesMessagesWrapper>;
    $[0] = children;
    $[1] = showLeftSidebar;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const WavesDesktopWithProvider: React.FC<Props> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ContentTabProvider><WavesDesktop {...props} /></ContentTabProvider>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default WavesDesktopWithProvider;